
export default function windowInnerSize(state = null, action) {
    switch (action.type) {
        case 'ui/windowInnerSize/add':{
            return action.payload
        }
        default:
            return state
    }
  }